import { render, staticRenderFns } from "./ActiveColumn.vue?vue&type=template&id=64eb99d4&"
import script from "./ActiveColumn.vue?vue&type=script&lang=js&"
export * from "./ActiveColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports